import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { SoftjawsService } from '@infinitform/platform-core';
import { CLOUD_PLATFORM_CONFIG } from '../config';

@Injectable()
export class CloudSoftjawsService implements SoftjawsService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(CLOUD_PLATFORM_CONFIG);

  async getBundleUrl(projectId: string): Promise<string> {
    return lastValueFrom(
      this.http.get(
        `${this.config.apiBaseUrl}/project/${projectId}/softjaws/download-bundle`,
        { responseType: 'text' },
      ),
    );
  }
}
